module.exports = __webpack_public_path__ + "img/user-profile.14617f6e.jpg";